import {
	apiRequest
} from '../api.js'

// 获取qc小组能不能申报
export function getQCteamCan(config){
	config.method = 'get'
	config.url = '/proapi/v1/project/check-is-member'
	apiRequest(config)
}

//获取项目列表
export function getAppliInfo(config){
	config.method = 'get'
	config.url = '/proapi/v1/project/get-project-list'
	apiRequest(config)
}

//获取项目列表
export function getPmHzData(config){
	config.method = 'get'
	config.url = '/proapi/v1/project/get-pm-hz'
	apiRequest(config)
}

// 获取二级管理员
export function getSecondUser(config){
	config.method = 'get'
	config.url = '/proapi/v1/project/get-admin-list'
	apiRequest(config)
}

// 新增二级管理员
export function setSecondUser(config){
	config.method = 'post'
	config.url = '/proapi/v1/project/add-admin'
	apiRequest(config)
}

// 冻结二级管理员
export function freezeSecond(config){
	config.method = 'post'
	config.url = '/proapi/v1/project/use-or-close'
	apiRequest(config)
}

export function saveQaCode(config){
	config.method = 'post'
	config.url = '/proapi/v1/project/save-qacode'
	apiRequest(config)
}

// 同意推荐
export function agreeRecommend(config){
	config.method = 'post'
	config.url = '/proapi/v1/project/agree-recommend'
	apiRequest(config)
}

// 重置密码
export function resetPassword(config){
	config.method = 'post'
	config.url = '/proapi/v1/project/reset-pwd'
	apiRequest(config)
}

// 获取项目类型和状态
export function getProjectType(config){
	config.method = 'get'
	config.url = '/proapi/v1/project/get-project-type'
	apiRequest(config)
}

export function getProjectHzb(config){
	config.method = 'get'
	config.url = '/proapi/v1/project/get-project-apps'
	apiRequest(config)
}